<template>
    <div class="row container-fluid mt-1 p-0 g-3 input file-panel flex-column flex-md-row align-items-center">
        <div class="p-0 empty-wrapper m-0" v-if="this.files.length == 0 && this.fileIsImage && single">
            <div class="empty-wrapper-icon">
                <Icon name="empty-uploader" size="c28" />
            </div>
        </div>
        <div class="input-wrapper p-0 m-0" :class="{'container-uploader': this.files.length == 0 && this.$store.state.resize.w >= 768 && this.fileIsImage && single}">
            <div class="input-filecontainer wid"> 
                <div v-if="this.files.length > 0" class="d-flex align-items-stretch justify-content-start gap-4" :class="{ 'flex-column-reverse align-items-stretch': !single || !fileIsImage }">
                    <div class="d-flex flex-column gap-1">
                        <div
                            v-for="(file, index) in this.files" 
                            :key='index' 
                            class="d-flex file-panel"
                            :class="{ 'gap-0': this.disabled, 'flex-md-row flex-column': fileIsImage && single, 'flex-column-reverse non-image': !fileIsImage || !single, 'align-items-stretch': this.$store.state.resize.w < 768, 'align-items-center': this.$store.state.resize.w >= 768 }"
                        >
                            <div class="d-flex justify-content-start align-items-center" :class="{ 'w-100': !fileIsImage || !single }">
                                <div
                                    class="d-flex justify-content-center align-items-center"
                                    :class="{ 'image-uploaded-wrapper': single, 'w-100': !single }"
                                    v-if="file.image"
                                >
                                    <!-- Если один файл и это изображение -->
                                    <img 
                                        v-if="single"
                                        class="image-uploaded" 
                                        :class="{'border-r': this.border}" 
                                        :id="id + '_' + index + '_img'" 
                                        :src='file.image'
                                    >
                                    <!-- Если изображений несколько -->
                                    <div v-else class="d-flex align-items-center justify-content-between pr-1 border-full p12 rounded12 w-100" :id="id + '_' + index + '_name'">
                                        <div class="d-flex align-items-center w-100">
                                            <div class="icon-bg flex-shrink-0">
                                                <Icon name="empty-uploader" :active="false" size="c12" :stroke_width="3" />
                                            </div>
                                            <span class="neue fsp14 lh20 text-black ml8 text-truncate">{{ file.name }}</span>
                                        </div>
                                        <span v-if="!this.disabled" class="pointer">
                                            <Icon @click="this.deleteFile(index)" name="close" size="c18" />
                                        </span>
                                    </div>
                                </div>
                                <!-- PDF -->
                                <div v-else class="d-flex align-items-center gap-2 justify-content-between pr-1 border-full p12 rounded12 w-100" :class="{ 'bg-light-grey': this.disabled }">
                                    <div class="d-flex align-items-center w-100">
                                        <div class="icon-bg flex-shrink-0">
                                            <Icon name="file-text" size="c16" />
                                        </div>
                                        <div class="d-grid flex-grow-1">
                                            <span class="neue fsp14 lh20 text-black ml8 text-truncate">{{ file.name }}</span>
                                        </div>
                                        <div @click="this.openPdf(file)" class="menu-bg neue fsp14 lh20 text-decoration-underline pointer ml8">{{ $t('components.service.File.13') }}</div>
                                    </div>
                                    <span v-if="!this.disabled" class="pointer">
                                        <Icon @click="this.deleteFile(index)" name="close" size="c18" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center gap-2">
                        <div class="input-file-container d-flex justify-content-center align-items-center wid">
                            <div class="wid">
                                <label
                                    class="d-flex flex-column align-items-center text-center label-text neue-roman"
                                    :for='"index_" + this.files.length + "_" + this.id'
                                    :id="id + '_select'"
                                    :class="{'dis_file': this.disabled}"
                                    @dragover.prevent="$event.dataTransfer.dropEffect = 'copy'"
                                    @dragenter.prevent="$event.dataTransfer.dropEffect = 'copy'"
                                    @drop="handleDrop($event)"
                                >
                                    <Icon :name="'uploader'" :size="'c40'" />
                                    <span class="d-flex flex-column align-items-center">
                                        <span>
                                            <span class="neue menu-bg mr4">
                                                {{ $t('components.service.File.14') }}
                                            </span>
                                            <span class="neue-roman primary-grey">
                                                {{ $t('components.service.File.15') }}
                                            </span>
                                        </span>
                                        <span v-if="this.fileInfoText" class="neue-roman primary-grey">
                                            {{ this.fileInfoText }}
                                        </span>
                                    </span>
                                </label>
                            </div>
                            <input
                                class='input-filecontainer-input' 
                                :id="'index_' + this.files.length  + '_' + this.id" 
                                type='file' 
                                :disabled='this.disabled'  
                                v-on:input="(e) => this.getFile(e, this.files.length)"
                            >
                        </div>
                        <div v-if="this.verification || this.unvisible" class="d-flex flex-row align-items-center justify-content-end gap-2">
                            <Popper v-if="this.verification" :hover="true":id="id + '_check'">
                                <Icon name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                                <template #content>
                                    <span>{{ $t('views.InfoReg.3') }}</span>
                                </template>
                            </Popper>
                            <Popper v-if="this.unvisible" :hover="true" :id="id + '_av'">
                                <SwitchSimple
                                    :id="id + '_switch_id'" 
                                    :dataValue='this.unvisibleValue' 
                                    :disabled="this.is_public == '2' ? true : false" 
                                    :type="'sm'" 
                                    @updateParentState="this.setUnvisibleValue"
                                />
                                <template #content>
                                    <span>{{ $t('views.InfoReg.4') }}</span>
                                </template>
                            </Popper>
                        </div>
                    </div>
                </div>
                <div v-else class="input-file-container d-flex align-items-center" :class="{ 'border-full bg-light-grey justify-content-start px12': this.disabled && !this.fileIsImage, 'justify-content-center': !this.disabled && this.fileIsImage }">
                    <div 
                        v-if="this.disabled" 
                        class="d-flex flex-wrap justify-content-start h56" 
                        :class="{'flex-column': file.image, 'flex-row align-items-center': !file.image }"
                    >
                        <div class="d-flex align-items-center">
                            <div class="empty-file">
                                <Icon name="file-question" size="c16" />
                            </div>
                            <div class="neue primary-grey ml8 fsp14 lh20">
                                {{ $t('components.service.File.12') }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="wid">
                        <div class="wid">
                            <label  
                                class="d-flex flex-column align-items-center text-center label-text" 
                                :for='"index_" + this.files.length + "_" + this.id' 
                                :id="id + '_select'" 
                                :class="{'dis_file': this.disabled}"
                                @dragover.prevent="$event.dataTransfer.dropEffect = 'copy'"
                                @dragenter.prevent="$event.dataTransfer.dropEffect = 'copy'"
                                @drop="handleDrop($event, id + '_select')"
                            >
                                <Icon :name="'uploader'" :size="'c40'" />
                                <span class="d-flex flex-column align-items-center">
                                    <span>
                                        <span class="neue menu-bg mr4">
                                            {{ $t('components.service.File.14') }}
                                        </span>
                                        <span class="neue-roman primary-grey">
                                            {{ $t('components.service.File.15') }}
                                        </span>
                                    </span>
                                    <span v-if="this.fileInfoText" class="neue-roman primary-grey">
                                        {{ this.fileInfoText }}
                                    </span>
                                </span>
                            </label>
                        </div>
                        <input
                            class='input-filecontainer-input'
                            :id='"index_" + this.files.length  + "_" + this.id'
                            :disabled='this.disabled'
                            type='file'
                            v-on:input="(e) => this.getFile(e, this.files.length)"
                        >
                    </div>
                </div>
            </div>
            
        </div>
    </div> 
</template>

<script>
import Lib from '@/includes/lib.js';
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon.vue';
import Popper from '@/components/service/Popper';

export default { 
    components: {
        Tooltip,
        SwitchSimple,
        Icon,
        Popper
    },
    data() {
        return {
            file: this.dataValue && !this.arr ? this.getDataValue(this.dataValue, this.fileName ? this.fileName : 'n') : '',
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
            files: [],
            image: '',
            type: '',
            name: this.fileName ? this.fileName : false,
            knownFormats: this.formats ? this.formats : [
                'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'application/pdf', "application/vnd.ms-excel", 
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv", 'image/svg+xml',
                "text/xml", 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                "application/vnd.openxmlformats-officedocument.wordprocessingml.template", "application/vnd.ms-word.document.macroEnabled.12",
            ]
        }
    },
    props: {
        id: [String, Boolean],
        label: [String, Boolean],
        arr: {
            type: [Boolean],
            default: false,
        },
        needBin: {
            type: [Boolean],
            default: false,
        },
        returnFileObject: [Boolean],
        single: [Boolean],
        hint: [String],
        dataValue: [String, Boolean, Object],
        fileName: [String, Boolean],
        require: [Boolean],
        verification: [String, Boolean],
        formats: [Array, Boolean],
        border: [String, Boolean],
        unvisible: [Boolean],
        disabled: [String, Boolean], 
        unvisibleDataValue: [String, Boolean], 
        is_public: [Boolean, String],
        vMark: [Boolean],
        maxSize: [Number, Boolean],
        fileIsImage: {
            type: [Boolean],
            default: true,
        },
        fileInfoText: {
            type: [String, Boolean],
            default: 'SVG, PNG or JPG',
        },
    },
    created() {
    console.log('created', this);
        if (this.file) {
            this.convertFile();
        }
        if (this.dataValue) {
            this.files = this.dataValue;
            this.getDataValue(this.dataValue);
            // console.log('this.dataValue', this.dataValue)
        }
    },  
    mounted() {
    },
    watch: {
        dataValue: {
            handler: function(newData, oldData) {
                this.files = newData;
                //this.getDataValue(newData);
            },
        },
    },
    methods: {
        base64ToBlob(base64, mime = 'application/pdf') {
            const binary = atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            return new Blob([bytes], { type: mime });
        },
        openPdf(file) {
            const b64 = file?.body;
            if (!b64) return;
            const blob = this.base64ToBlob(b64, 'application/pdf');
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank', 'noopener,noreferrer');
            setTimeout(() => URL.revokeObjectURL(url), 60000); // освобождаем через минуту
        },
        getDataValue(val, name = 'undefined_name') {
                // console.log(this.files);
            for(let i = 0; i < this.files.length; i++) {
                if (this.files[i].file_link) {
                    this.files[i].image = this.files[i].body;
                    this.files[i].name_base64 = this.files[i].name;
                    try {
                        this.files[i].name = atob(this.files[i].name); 
                    } catch(err) {
                        this.files[i].name = this.files[i].name; 
                    }
                } else if (!this.files[i].image) {
                    this.getBase64Arr(this.objectToFile(this.files[i]), i);
                }
            }
            
        },
        setUnvisibleValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id.replace(/_switch_id/, ''),
                unvisible: true,
                value: arg.value
            })
        },
        getFile(e, id, isID=true, file=false) {
            console.log('getFile', e, id, isID, file);
            let fileObject = isID ? document.querySelector(`#index_${id}_${this.id}`).files[0] : file;
            if (this.maxSize && (fileObject.size / (1024 * 1024) > this.maxSize )) {
                alert(this.$t('components.service.File.4') + ' ' + this.maxSize + ' MB');
                fileObject.value = '';
                return;
            }
            if (this.checkFormat(fileObject)) {
                this.convertFileInArray(fileObject, id);
            }
            if (e.target) {
                e.target.value = '';
            }
        },
        checkFormat(file = this.file) {
            if (this.knownFormats) {
                let ok = false;
                let warn = this.$t('components.service.File.2');
                this.knownFormats.forEach(e => {
                    if (e == file.type) {
                        ok = true;
                    }
                    warn = warn + ' ' + e;
                })
                if (!ok) {
                    const warningObject = {
                        warningType: 'error',
                        warningText: warn,
                    };
                    this.$store.commit("WARNING", warningObject);
                    return false;
                }
                return true;


            } else {
                return true;
            }
        },
        // Потом нужно убрать как будут массивы
        convertFile() {
            if (this.file.type == 'image/jpeg' || this.file.type == 'image/jpg' || this.file.type == 'image/png' || this.file.type == 'image/svg+xml') {
                this.type = this.file.type;
                this.getBase64()
            } else if (this.file.type == 'application/pdf') {
                this.type = this.file.type;
                this.name = this.file.name;
                this.getBase64()
            }else {
                alert(`${this.$t('components.service.File.3')} ${this.file.type}`) 
            }
        },
        convertFileInArray(file, id) {
            if (Lib.inArray(file.type, this.knownFormats)) {
                this.getBase64Arr(file, id);
            } else {
                alert(`${this.$t('components.service.File.3')} ${file.type}`) 
            }
        },
        getBase64Arr(file, i) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let res = {};
                res.name = file.name;
                res.type = file.type;
                res.size = file.size;
                if (this.needBin) {
                    res.full_result = reader.result;
                }
                if (this.returnFileObject) {
                    res.fileObject = document.querySelector(`#index_${i}`).files
                }
                res.body = reader.result.split(',')[1];
                if (Lib.inArray(file.type, ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif', 'image/svg+xml'])) {
                    res.image =  reader.result;
                } else {
                    res.image =  '';
                }
                // this.setValue();
                if (this.single) {
                    this.files = [res];
                } else {
                    this.files.push(res);
                }
                this.setArrValue({id: this.id, files: this.files});
            };
            reader.onerror = function (error) {
                alert(error);
                return false;
                
            };
        },
        deleteFile(ind) {
            this.files.splice(ind, 1);
            this.setArrValue({id: this.id, files: this.files});
        },
        getBase64() {
            var reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = () => {
                this.file = reader.result;
                if (this.type == 'application/pdf') {
                    this.image = ''
                } else {
                    this.image = reader.result;
                }
                this.setValue();
            };
            reader.onerror = function (error) {
                this.file = false;
                this.image = false; 
                this.setValue(); 
            };
        },
        dataURLtoFile(dataurl, filename) {
            // console.log(dataurl);
            var arr = dataurl.split(',');
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            let u8arr = new Uint8Array(n);
     
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
 
            return new File([u8arr], filename, {type:mime});
        },
        objectToFile(obj) {
            let mime = obj.mime,
            bstr = atob(obj.body),
            n = bstr.length,
            u8arr = new Uint8Array(n);
     
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
 
            return new File([u8arr], obj.name, {type:mime});
        },
        setValue() {
            this.$emit('updateParentState', {
                id: this.id,
                value: this.file,
            })
        },
        setArrValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.files,
            })
        },
        handleDrop(event, id) {
            event.preventDefault();
            const file = event.dataTransfer.files;
            this.getFile(false, id, false, file[0]);
        },
    },

}
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row; 
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
    &-filecontainer {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        height: 100%;
        label {
            color: $color-href;
            cursor: pointer;
        }
        img {
            max-width: 10rem;
        }
        &-input {
            display: none;
        }

    }
}
.border-r {
    border-radius: 0.5rem !important;
}
.dis_file {
    color: $color-grey !important;
    cursor: default !important;
}

.container-uploader {
    width: calc(100% - 167px);
}

.file-panel {
    gap: 24px;

    &.non-image {
        gap: 16px;
    }
    
    @media (max-width: 768px) {
        gap: 16px;
    }
}

.empty-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24px;
    &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 96px;
        height: 96px;
        background: $bg-light-grey;
        border-radius: 50%;
        border: 1px solid $primary-stroke;
    }
}

.empty-wrapper, 
.image-uploaded-wrapper {
    width: 143px;
    height: 143px;
    border-radius: 12px;
    border: 1px solid $primary-stroke;

    @media (max-width: 768px) {
        width: 100%;
        height: 128px;
    }
}

.image-uploaded {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    object-fit: cover;
}

.input-file-container {
    border: 1px dashed $menu-bg;
    border-radius: 12px;
    min-height: 100%;
}

.label-text {
    font-size: 16px;
    line-height: 24px;
    width: 100%;
    gap: 16px;
    padding: 19px;
}

.icon-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: $bg-light-blue;
    border: 1px solid $primary-stroke;
    border-radius: 50%;
}

.empty-file {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: $bg-light-blue;
    border: 1px solid $primary-stroke;
}
</style>